
import {defineComponent} from "vue";

export default defineComponent({
  name: 'PublicOfferPage',
  props: {
    serviceCode: {
      type: String,
      required: true
    }
  },
  setup: function () {
    return {}
  }
})
